import { IAction, IActionHandler, Store } from 'models/services'
import { AttributeSchema, PageSchema, UrlSchema, UserSchema } from 'models'
import { PageTemplateSchema } from 'models/PageTemplateSchema'

/**
 * A job to get initial data on first load
 * By default it will only be called once every 30m,
 * otherwise assuming all data is cached
 */
export class HANDSHAKE implements IActionHandler<any, any> {
  async exec(action: IAction<any>, store: Store) {
    const Url = store.getModel(UrlSchema)
    const Users = store.getModel(UserSchema)
    const now = Date.now()
    const lastSync = parseInt(store.getSetting('last_sync', ''))
    await Url.GET_COLLECTION()

    if (!lastSync || lastSync > (now + (1000 * 60 * 60 * 30))) {
      store.cache.addToCache('pages:', 10000)
      store.cache.addToCache('attributes:', 10000)

      const params = lastSync ? { now, since: lastSync } : {}
      const { response, status } = await store.API.GET('/editor/handshake', {}, params)
      const Attributes = store.getModel(AttributeSchema)
      const Pages = store.getModel(PageSchema)
      const Templates = store.getModel(PageTemplateSchema)
      const [user, attributes, pages, templates] = await Promise.all([
        Users.PERSIST(response.current_user),
        Promise.all(response.attributes.map(async (attr: any) => Attributes.PERSIST(attr))),
        Promise.all(response.pages.map(async (page: any) => Pages.PERSIST(page))),
        Promise.all(response.page_templates.map(async (template: any) => Templates.PERSIST(template))),
      ])

      if (user.id) {
        UserSchema.setSession(store, user)
        store.setSetting('last_sync', now.toString())
      }
      return { status, response, changes: { user, attributes, pages, templates } }
    } else {
      const activeUserId = store.getSetting('active_user', '')
      if (activeUserId) {
        const user = await Users.GET_BY_KEY_VALUE('username', activeUserId)
        if (user !== null) { UserSchema.setSession(store, user)}
      }
      return { cached: true, lastSync, activeUserId }
    }
  }
}
